// extracted by mini-css-extract-plugin
module.exports = {"nowrap":"OverflowingTextTip_nowrap__UYc7B","text":"OverflowingTextTip_text__h_YlG","withCopyToClipboardSupport":"OverflowingTextTip_withCopyToClipboardSupport__V0k2d"};